import { useNavigate, useParams } from "react-router-dom";
import EditQuizBlueprintForm from "../../components/quizBlueprint/EditQuizBlueprintForm";

const EditQuizBlueprint = () => {

  const { quizId } = useParams();

  const navigate = useNavigate();


  return (
    <EditQuizBlueprintForm
      quizId={quizId}
      onSuccess={() => navigate(`/quizzes/${quizId}`)}
    />
  );
};


export default EditQuizBlueprint;